import { IMagazineResult, IMagazineCategory, IMagazineCategoryArticleResult } from '../models/magazine-result';
import { IResponseLower } from 'core-max-lib';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class MagazineService {
    abstract magazineDetails: IMagazineResult;
    abstract getLobby(page: number, category: string): Observable<IResponseLower<IMagazineResult>>;
    abstract getMagazineArticle(articleUrlName: string, categoryUrlName: string): Observable<IResponseLower<IMagazineCategoryArticleResult>>;
    abstract getGeneralArticle(articleUrlName: string, categoryUrlName: string): Observable<IResponseLower<IMagazineCategoryArticleResult>>;
    abstract redirectToErrorPage();
    abstract insertStylesFix();
    abstract removeStylesFix();
    abstract getQAndAExpandIconUrl(): string;
    abstract getQAndACollapseIconUrl(): string;
    abstract getLobbyMagazineTitleTextColor(): string;
    abstract isMobile(): boolean;
    abstract pushToGtm(action: string, label: string);
    abstract navigateToJobs();
}

export interface ILcImage {
    url: string;
    alt: string;
}
